import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
  customerId: string;
  type: string;
}

export const useCompleteStripeConnectionMutation = () => useMutation('useCompleteStripeConnectionMutation', async ({ customerId, type }: IProps) => {
  const res = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/paymentOptions/${type}/complete`, { completed: 'true' });
  return res.data;
}, { retry: 1 });
